import { isDevMode } from '@angular/core';

/**
 * Открытая папка с медиа онбординга: ролики, обложки, манифест и плейлист. Ключа окружения нет —
 * на dev-сервере папку отдаёт прокси `/onboarding-media` из локальной папки синхронизации,
 * в сборке адрес ведёт прямо в открытое хранилище компании.
 */
export const ONBOARDING_MEDIA_BASE = isDevMode()
  ? '/onboarding-media'
  : 'https://public-files.lumir.photo/fotoklass/onboarding-media';
